const routes = [
    {
        name: 'listarRelatoriosAtendimentos',
        path: 'relatorios',
        alias: 'relatorios/index',
        component: () => import('../views/Listar')
    },
    {
        name: 'formularioRelatoriosAtendimento',
        path: 'relatorios/relatorio_chamados',
        component: () => import('../views/Chamado')
    },
    {
        name: 'impressaoRelatorio',
        path: 'relatorios/:tipo/gerar',
        component: () => import('@/shared/components/ui/Relatorio')
    },
]

export default routes
